import LogoutComponent from './Logout.component';

export default LogoutComponent;
